import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';

const BlockConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Modal.Header title={modalProps.title ?? t('block_confirmation')} subtitle={modalProps.subtitle} />
      <Modal.Footer
        confirmText={modalProps.confirmText ?? t('block')}
        confirmAction={modalProps.func}
        dontCloseOnConfirm={modalProps.dontCloseOnConfirm}
        closeButtonText={modalProps.backText ?? t('annulla')}
      />
    </>
  );
};

export default BlockConfirmationModal;
